import { U as Url } from './url.min.js';

/**
 * **Bookassist**
 *
 * Official: www.bookassist.com
 *
 * Example 1: http://www.bookassist.com/cb/c_1.jsp?user_language=es&set_curr_menu=0&user_currency=EUR&inday=28&inmonthyear=2018-02&outday=1&outmonthyear=2018-03&infants=0&voucher_code=FOO&vgt7609=0&vgo7609=1&rpt74917=0&rpt74919=0&rpt74920=0&rpt74921=0&rpt74922=0&rpt74923=0&rpt74926=0&rpt74927=0&rpt74928=0&rpt74929=0&rpt74930=0&rpt74931=0&vgt7611=0&vgo7611=1&rpt74924=0&rpt74925=0&rpt77826=0&rpt77827=0&rpt77828=0&rpt77829=0&rpt77830=0&rpt77831=0&rpt77860=0&rpt77861=0&vgt7612=0&vgo7612=1&rpt74936=0&rpt74937=0&rpt77821=0&rpt77822=0&rpt77824=0&rpt77825=0&vgt7610=0&vgo7610=1&rpt74932=0&rpt74933=0&rpt77832=0&rpt77833=0&rpt74934=0&rpt74935=0&rpt77834=0&rpt77835=0&rpt77836=0&rpt77837=0&from_page=c_1.jsp&cp=%2Fcb%2Fc_1.jsp&service_model=2&bp=http%3A%2F%2Fwww.hotelmanfredi.it%2Fen%2Freservations%2F%3Fdate_in%3D2018-02-28%26date_out%3D2018-03-01%26ms_in%3D1519772400000%26ms_out%3D1519858800000%26promo_code%3DFOO&guide_id=808&hotel_id=2911&pr=true&rms=0&adults=2&children=0&action=c_1.jsp
 * Example 2 (form Hotel iframe): http://www.hotelmanfredi.it/en/reservations/?date_in=2018-02-28&date_out=2018-03-01&ms_in=1519772400000&ms_out=1519858800000&promo_code=FOO
 *
 * @exports bs_2
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let refreshPrice;
    let refreshPriceV4;
    /**
       * @memberOf module:bs_2
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux;
            // Home page language except reservation
            if (thn.data.propertyId === 1026853 && !window.location.pathname.match(/reservas.html/)) {
                aux = (document.querySelector('.milenia-dropdown--languages button') || {}).textContent;
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
            }
            aux = window.location.pathname.match(ctx.urlRe);
            if (aux) {
                aux = aux[1].toLowerCase();
                if (aux === 'po') {
                    aux = 'pt';
                }
                if (ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
            }
            aux = thn.parseUrlParameter('user_language', window.location.search, true);
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            if (window.user_language && ctx.langs.test(window.user_language)) {
                resolve(window.user_language);
                return;
            }
            if (window.language && ctx.langs.test(window.language)) {
                resolve(window.language);
                return;
            }
            thn.domReady().then(function () {
                const $ = window.jQuery;
                aux = $ && $('#user_language').val();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                reject('no_language');
            }); // on domReady
        });
    };
    engine._getBookingIframe = function getBookingIframe() {
        return document.getElementById('booking_frame');
    };
    engine.inlinerGetContext = function inlinerGetContext() {
        const iframe = engine._getBookingIframe();
        const roomsAndRatesUrl = iframe?.getAttribute('src');
        if (!roomsAndRatesUrl) {
            return {};
        }
        return {
            roomsAndRatesUrl,
        };
    };
    /**
       * Forbid execution on:
       * - atahotels.it if not corpo script
       *
       * @memberOf module:bs_2
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation() {
        let isAllowedLocation = true;
        // Forbid hotel scripts exec on the Atahotels.it home
        if (thn.data.accountUserId === 1032645
            && thn.data.mode === 'hotel'
            && window.location.hostname === 'www.atahotels.it'
            && window.location.pathname.match(/^(\/(\w{2}\/?)?)?$/)) {
            isAllowedLocation = false;
        }
        return isAllowedLocation;
    };
    /**
       * @memberOf module:bs_2
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        return false;
    };
    /**
       * @memberOf module:bs_2
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        let url = new Url(ctx.baseUrl);
        // example1: http://www.bookassist.com/cb/c_1.jsp?user_language=es&set_curr_menu=0&user_currency=EUR&inday=28&inmonthyear=2018-02&outday=1&outmonthyear=2018-03&infants=0&voucher_code=FOO&vgt7609=0&vgo7609=1&rpt74917=0&rpt74919=0&rpt74920=0&rpt74921=0&rpt74922=0&rpt74923=0&rpt74926=0&rpt74927=0&rpt74928=0&rpt74929=0&rpt74930=0&rpt74931=0&vgt7611=0&vgo7611=1&rpt74924=0&rpt74925=0&rpt77826=0&rpt77827=0&rpt77828=0&rpt77829=0&rpt77830=0&rpt77831=0&rpt77860=0&rpt77861=0&vgt7612=0&vgo7612=1&rpt74936=0&rpt74937=0&rpt77821=0&rpt77822=0&rpt77824=0&rpt77825=0&vgt7610=0&vgo7610=1&rpt74932=0&rpt74933=0&rpt77832=0&rpt77833=0&rpt74934=0&rpt74935=0&rpt77834=0&rpt77835=0&rpt77836=0&rpt77837=0&from_page=c_1.jsp&cp=%2Fcb%2Fc_1.jsp&service_model=2&bp=http%3A%2F%2Fwww.hotelmanfredi.it%2Fen%2Freservations%2F%3Fdate_in%3D2018-02-28%26date_out%3D2018-03-01%26ms_in%3D1519772400000%26ms_out%3D1519858800000%26promo_code%3DFOO&guide_id=808&hotel_id=2911&pr=true&rms=0&adults=2&children=0&action=c_1.jsp
        // example2 (form Hotel iframe): http://www.hotelmanfredi.it/en/reservations/?date_in=2018-02-28&date_out=2018-03-01&ms_in=1519772400000&ms_out=1519858800000&promo_code=FOO
        // example3: https://m.deandublin.ie/ChooseRooms?action=c_1&arrival=15&av_price=false&bp=https%3A%2F%2Fdeandublin.ie%2Fbooking%2F%3Fuser_language%3Den%26adults%3Dundefined%26promo_code%3D&ch=0&date_in=2019-10-17&date_out=2019-10-19&dlink_f=13&guide_id=1&hotel_group_id=0&hotel_id=3535&payment=All_charges_to_company&paymentOption=Guest_pays_hotel_directly&price_group=2&rp_vg_row=true&service_model=5&user_currency=EUR&user_language=en#/
        // example4: (mobile) https://mbe.bookassist.com/ChooseRooms?_ga=2.199736366.1638497976.1566548421-141080743.1563454228&action=c_1&arrival=14&av_price=false&bp=https%3A%2F%2Fwww.hotelmanfredi.it%2Fen%2Freservations%2F%3Fdate_in%3D2019-08-23%26date_out%3D2019-08-24%26ms_in%3D1568066400000%26ms_out%3D1568152800000%26promo_code%3DORACULO&ch=0&date_in=2019-08-23&date_out=2019-08-24&guide_id=808&hotel_group_id=0&hotel_id=2911&payment=All_charges_to_company&paymentOption=Guest_pays_hotel_directly&price_group=1073741824&rp_vg_row=true&service_model=5&user_currency=EUR&user_language=en#/
        // example5: (Hotel wrapper page) .../booking/?action=c_1&hotel_id=2049&guide_id=854&user_language=en&date_in=2019-12-16&date_out=2019-12-17&promo_code
        const isMobile = url.host.match(/^m(be)?\./); // No iframe
        const validUrl = !!(url.query.date_in && url.query.date_out); // Rooms and Rates
        const promocodeVars = thn.data.promocodeVars.default;
        let prepareQueryParams = false; // Prepare query params only if we have a valid URL
        if (window.booking_page
            && ![1037009].includes(thn.data.accountUserId)) { // Not all pages that have booking_page have the complete path + query string
            // Some wrapper pages have the 'example5' url structure.
            // window.booking_page contains the starting path + query string (similar to: booking?action=c_1&hotel_id=2049&guide_id=854)
            // to where we can append all the required info and create a valid search URL.
            // First, we create a new URL with the current host and the found variable.
            url = new Url(`${window.location.protocol}//${window.location.hostname}/${window.booking_page}`);
            // Add remaining query params
            prepareQueryParams = true;
        }
        else if (validUrl) {
            // Note links will redirect to the iframed child page if there is a code present in its URL, instead of doing it via POST.
            // Detect if the parent url contains any of the promocodeVars and prioritise its replacement.
            const parentUrl = (url.query.bp && url.query.bp.length > 1) ? new Url(url.query.bp[0]) : new Url(url.query.bp);
            if (!isMobile
                && parentUrl
                && promocodeVars
                && promocodeVars.some((promoVar) => promoVar in parentUrl.query)) {
                // Use parent url (example 2)
                url = parentUrl;
            }
            else if (promocodeVars) {
                // Prioritise POST for desktop removing autogenerated empty vars
                // mobile will automatically use GET as there is no code input
                promocodeVars.forEach((promoVar) => {
                    if (promoVar in url.query && !thn.parseUrlParameter(promoVar, ctx.baseUrl)) {
                        delete url.query[promoVar];
                    }
                });
            }
            // Add remaining query params
            prepareQueryParams = true;
        }
        else {
            // This is not a valid BE URL
            ctx.newUrl = '';
        }
        if (prepareQueryParams) {
            // General query values, prepare URL for params substitution
            // Language
            url.query.user_language = '[language]';
            // Do dates substitution only if we have the data
            if (ctx.newData.dateBegin
                && ctx.newData.dateEnd) {
                url.query.date_in = '[date_begin]';
                url.query.date_out = '[date_end]';
                // remove some params
                delete url.query.inday;
                delete url.query.inmonthyear;
                delete url.query.outday;
                delete url.query.outmonthyear;
            }
            // export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
            // then format of dates: yyyy/mm/dd -> yyyy-mm-dd
            ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.newData.dateEnd && ctx.newData.dateEnd.replace(/\//g, '-');
            // language
            ctx.newData.language = ctx.newData.language || thn.data.language;
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_2
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = thn.debounce(function () {
        thn.languageCheck();
        thn.pageCheck();
    }, 500);
    /**
       * @memberOf module:bs_2
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const rooms = document.querySelector('.v10-container, #wrapper');
        /* The user can change between two sections (All rooms / Your Offer)
                which display different rates. */
        if (rooms && !refreshPrice) {
            refreshPrice = thn.debounce(() => {
                // Refresh PW
                ctx.widget.refresh();
            }, 700);
            // Init body observation
            thn.observeDom(rooms, refreshPrice, {
                childList: true,
                subtree: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(rooms, refreshPrice);
            });
        }
        // Price v4
        const mainContainer = document.querySelector('main');
        if (mainContainer && !refreshPriceV4) {
            refreshPriceV4 = thn.debounce(ctx.widget.refresh, 400);
            thn.observeDom(mainContainer, refreshPriceV4, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.pageUnload(() => {
                thn.stopObserveDom(mainContainer, refreshPriceV4);
            });
        }
    };
    engine._hasPriceGroup = function _hasPriceGroup() {
        // hotels that must avoid showing the price widget on "Offers" pages
        const priceGroup = thn.parseUrlParameter('price_group')
            // referrer url stored in a variable (bp contains the referrer with more parameters to parse)
            || thn.parseUrlParameter('price_group', thn.parseUrlParameter('bp'));
        const priceGroupBlacklist = priceGroup
            && [
                1011253, // Luxury Suites Madrid
                1011848, // Apostrophe Hotel
                1010905, // Aparthotel Puerto Azul Marbella
                1015167, // Grand Canal Hotel
                1014019, // hotel chiqui
                1024381, // Hotel Madinat
                1010873, // Lusso Infantas
                1024668, // Hotel Monte Triana
                1024667, // Hotel Monte Carmelo
                1024762, // Hotel Casa Granada
                1024761, // Hotel Casa Sevilla
                1014202, // The Montenotte Hotel
                1015987, // Parknasilla Resort & Spa
                1016567, // Fontecruz Sevilla
                1026698, // Fontecruz Avila
                1026700, // La Casa del Presidente
                1012766, // Los Cauquenes Resort
                1027471, // Cassidy's Hotel
                1014442, // Academy Plaza Hotel
                1027752, // The Wilder Townhouse
            ].includes(thn.data.propertyId);
        // These hotels have a valid price_group value "2", and an invalid one "8192"
        const validPriceGroup = priceGroup
            && priceGroup === '2'
            && [
                1024668, // Hotel Monte Triana
                1024667, // Hotel Monte Carmelo
            ].includes(thn.data.propertyId);
        if (priceGroup
            && priceGroupBlacklist
            && !validPriceGroup) {
            return true;
        }
        return false;
    };
    engine._priceParseDataCommon = function (ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const BA = window.BA && window.BA.rrDoc;
        // If price group filter is present, set special price
        if (engine._hasPriceGroup()) {
            widgetData.priceSpecial = 1;
        }
        /* IMPORTANT: From 2018-04-23 we check the following
             * properties in order to get the first search dates
             * from a different selector. This case happens when
             * no calendar page is available before R&R.
             */
        const exceptionDates = [
            // Hotel Forum Roma
            1013947,
        ].includes(thn.data.propertyId);
        // Default Dates
        if (BA) {
            widgetData.dateBegin = BA.arrival;
            widgetData.dateEnd = BA.departure;
        }
        // Exception Dates
        if ($ && (!widgetData.dateBegin || !widgetData.dateEnd) && exceptionDates && window.location.hostname !== 'm.bookassist.com') {
            const dateIn = `${$('#inmonthyear').val().replace('-', '/')}/${$('#inday').val()}`;
            const dateOut = `${$('#outmonthyear').val().replace('-', '/')}/${$('#outday').val()}`;
            widgetData.dateBegin = dateIn;
            widgetData.dateEnd = dateOut;
        }
        if (widgetData.dateBegin && widgetData.dateEnd) {
            widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        return widgetData;
    };
    engine._childrenSelectorTranslations = function _childrenSelectorTranslations() {
        // Add any translation of Child and Children
        return /\d\s?(child|niño|nen|enfant|infant|bambino|bambini|kind|criança|ребенок|дети|детей)/i;
    };
    engine._calcSearchPeople = function _calcSearchPeople() {
        /*
            *   Calculate the "default" guests based on a hotel's preferences or user-input
            *
            *   Hotel wants 1 guest rooms to be shown when no user input:
            *   default to 1 guest
            *
            *   Hotel wants 2 guest minimum search when there's no user input:
            *   default to 2 guests
            *
            *   Normal & expected behavior:
            *   default to 2 guests, but lower to 1 if there's only one-guest-room results
            *   (This will be done separately in each price_parse_data version when handling the rooms)
            */
        // Default approach
        const defaultSearch = {
            guests: 2,
            adults: 2,
            children: 0,
            userInput: false,
        };
        // Set the minimum guests search
        const minimumSearch = {
            guests: 1,
            adults: 1,
            children: 0,
        };
        const avoidIndividualRooms = [
            // White Hotel Rome
            1013920,
            // Hotel Accademia Rome
            1013921,
            // Hotel Tritone
            1014982,
            // Hotel Elite Roma
            1014983,
        ].includes(thn.data.propertyId);
        const oneGuestByDefault = [
            // Mooons hotel
            1013529,
        ].includes(thn.data.propertyId);
        if (avoidIndividualRooms) {
            // Raise minimum guests to 2
            Object.assign(minimumSearch, { guests: 2, adults: 2 });
        }
        else if (oneGuestByDefault) {
            // Lower default guests to 1
            Object.assign(defaultSearch, { guests: 1, adults: 1 });
        }
        // guests user input?
        const adultsSelect = document.getElementById('adults_select');
        const childrenSelect = document.getElementById('children_select');
        const adultsFieldset = document.querySelector('fieldset#adults');
        if (adultsSelect
            && adultsFieldset
            && window.getComputedStyle
            && window.getComputedStyle(adultsFieldset).display !== 'none') {
            // re-init to zero
            defaultSearch.guests = 0;
            defaultSearch.adults = 0;
            defaultSearch.children = 0;
            // mark as user input
            defaultSearch.userInput = true;
            // adults
            defaultSearch.adults = parseInt(adultsSelect.value, 10) || 2;
            if (childrenSelect) {
                defaultSearch.children = parseInt(childrenSelect.value, 10) || 0;
            }
            // add, and consider 1 as the min
            defaultSearch.guests = Math.max(1, defaultSearch.adults + defaultSearch.children);
        }
        thn.logger.debug('Guests input:', defaultSearch);
        // Check if guests search fulfill the minimums required
        if (defaultSearch.guests < minimumSearch.guests) {
            Object.assign(defaultSearch, minimumSearch);
            thn.logger.debug('Guests input doesn\'t fulfill the minimum requirements!');
            thn.logger.debug('Guests input (modified):', defaultSearch);
        }
        return {
            defaultSearch,
            minimumSearch,
            // Mark a flag in order to get the search formatted if only one-guest-room results are visible
            isForcedSearch: avoidIndividualRooms || oneGuestByDefault,
        };
    };
    /*
      * @memberOf module:bs_2
      * @this thn.widgets.price
      * @see {@link Price#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        // Mobile version (OLD)
        const widgetData = engine._priceParseDataCommon(ctx);
        if (thn.data.media.name !== 'mobile') {
            return widgetData;
        }
        const $ = window.jQuery;
        const BA = window.BA && window.BA.rrDoc;
        if (!$ || window.location.hostname !== 'm.bookassist.com') {
            return widgetData;
        }
        const nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        const searchPeople = engine._calcSearchPeople();
        // Take care about guests for property: 1013947
        // Update the object search_people.adults to the numbers of guest selected
        if (BA && BA.numAdults && thn.data.propertyId === 1013947) {
            searchPeople.adults = BA.numAdults;
            // Update guests
            searchPeople.guests = searchPeople.adults + searchPeople.children;
        }
        // no special care with guests for the mobile version
        Object.assign(widgetData, searchPeople);
        const prices = $('.roomstayprice:visible').map(function (idx, el) {
            return thn.parseNumber(el.textContent);
        }).toArray();
        if (prices.length) {
            widgetData.price = Math.min(...prices) / nights;
            widgetData.currency = (window.BA && BA.rrDoc && (BA.rrDoc.userCurrencyCode || BA.rrDoc.currencyCode)) || widgetData.currency;
            widgetData.set = true;
            // Room Details Function Here
            widgetData.roomDetails = engine._roomDetailsParseData();
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /*
      * @memberOf module:bs_2
      * @this thn.widgets.price
      * @see {@link Price#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        // New Mobile Version
        const widgetData = engine._priceParseDataCommon(ctx);
        if (!window.location.hostname.match(/mbe.bookassist.com/) || !document.querySelector('#mbe')
            || document.querySelector('.v10-loading-layer')) {
            return widgetData;
        }
        // force dates from URL vars, others may not update on every search
        widgetData.dateBegin = (thn.parseUrlParameter('date_in') || '').replace(/-/g, '/');
        widgetData.dateEnd = (thn.parseUrlParameter('date_out') || '').replace(/-/g, '/');
        widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        const { defaultSearch, minimumSearch, isForcedSearch } = engine._calcSearchPeople();
        const mobilePeopleMap = {
            'icon-guest-one': {
                guests: 1, adults: 1, children: 0, max: 1,
            },
            'icon-guest-double': {
                guests: 2, adults: 2, children: 0, max: 2,
            },
            'icon-guest-three': {
                guests: 3, adults: 3, children: 0, max: 3,
            },
            'icon-guest-one-plus-one': {
                guests: 1, adults: 1, children: 0, max: 2,
            },
            'icon-guest-double-plus': {
                guests: 2, adults: 2, children: 0, max: 3,
            },
            'icon-guest-double-plus-one-child': {
                guests: 3, adults: 2, children: 1, max: 3,
            },
            'icon-guest-double-plus-two-children': {
                guests: 4, adults: 2, children: 2, max: 4,
            },
        };
        // Set up special when the package prices view is showed to avoid getting those prices (that are higher) for the price widget in the mobile version.
        if (document.querySelector('#showAll') && !document.querySelector('#showAll').checked) {
            widgetData.priceSpecial = 1;
        }
        // First, iterate through every rate and compare each price
        let price = Number.MAX_VALUE;
        let auxPrice;
        const rooms = Array.from(document.querySelectorAll('.v10-room-item, .v10-room-item-in-vg'));
        if (rooms.length) {
            // Collect rooms with one guest
            const roomsBelowThreshold = rooms.filter((rate) => {
                let occ = (rate.querySelector('.v10-room-item-occupancy i') || {}).className;
                occ = mobilePeopleMap[occ] || {};
                return occ.guests < defaultSearch.guests;
            });
            // Check if the search is default (no forced 1 pax/2 pax rooms) and correct search_people
            // lower guests search to 1 only when one-guest-rooms are visible
            if (!isForcedSearch
                && !defaultSearch.userInput
                && rooms.length === roomsBelowThreshold.length) {
                Object.assign(defaultSearch, minimumSearch);
            }
            rooms.forEach((rate) => {
                const auxPriceEl = rate.querySelector('.v10-room-price-final');
                auxPrice = auxPriceEl && thn.isVisible(auxPriceEl) && thn.parseNumber(auxPriceEl.textContent || '');
                if (auxPrice && auxPrice < price) {
                    // If needed, assign the rate capacity
                    let occ = rate.querySelector('.v10-room-item-occupancy i').className;
                    occ = mobilePeopleMap[occ];
                    // Some rooms has the class ".icon-guest-one" but its occupancy is much greather
                    // And example of that is "4 + adult icon"
                    // This happens when a room has a significant number of guests
                    // We should check if v10-room-item-occupancy has an span with the number (.v10-room-item-occupancy-numpeople)
                    const occupancyNumber = thn.parseNumber((rate.querySelector('.v10-room-item-occupancy span') || {}).textContent || '0');
                    if (occupancyNumber) {
                        occ = {
                            guests: occupancyNumber, adults: occupancyNumber, children: 0, max: occupancyNumber,
                        };
                    }
                    if (occ && occ.guests >= defaultSearch.guests) {
                        price = auxPrice;
                        // If a valid object for guests is found
                        defaultSearch.guests = occ.guests;
                        defaultSearch.adults = occ.adults;
                        defaultSearch.children = occ.children;
                    }
                }
            });
        }
        if (price !== Number.MAX_VALUE) {
            // Guests
            Object.assign(widgetData, defaultSearch);
            // Currency
            let mobCurrency = document.querySelector('.icon-settings-filled').nextElementSibling.textContent;
            if (mobCurrency) {
                mobCurrency = mobCurrency.split('-')[0].trim();
            }
            // Price
            const pricePerNight = thn.parseUrlParameter('av_price') === 'true';
            if (pricePerNight) {
                widgetData.price = price;
            }
            else {
                widgetData.price = price / widgetData.nights;
                widgetData.price = Math.round(widgetData.price * 100) / 100;
                // Hotel Miguel Angel mobile case
                if (thn.data.propertyId === 1016837) {
                    // is mobile?
                    if (document.querySelector('label[for=yourOffer]') && window.getComputedStyle(document.querySelector('label[for=yourOffer]')).backgroundColor === 'rgb(155, 155, 155)') {
                        // We can't ensure that the price is BAR
                        widgetData.priceSpecial = 1;
                    }
                }
                if ([1037184, 1033593].includes(thn.data.accountUserId) && (document.querySelector('#yourOffer') || {}).checked) {
                    widgetData.priceSpecial = 1;
                }
            }
            widgetData.currency = mobCurrency;
            widgetData.set = true;
            // Room Details Function Here
            widgetData.roomDetails = engine._roomDetailsParseData();
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /*
      * @memberOf module:bs_2
      * @this thn.widgets.price
      * @see {@link Price#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceParseData_v3 = function priceParseData_v3(ctx) {
        // Regular website version
        const widgetData = engine._priceParseDataCommon(ctx);
        const $ = window.jQuery;
        const BA = window.BA && window.BA.rrDoc;
        if (!$ || !widgetData.dateBegin || !widgetData.dateEnd) {
            return widgetData;
        }
        const { defaultSearch, minimumSearch, isForcedSearch } = engine._calcSearchPeople();
        const peopleMap = {
            one: {
                guests: 1, adults: 1, children: 0, max: 1,
            },
            two: {
                guests: 2, adults: 2, children: 0, max: 2,
            },
            onePlusOne: {
                guests: 1, adults: 1, children: 0, max: 2,
            },
            three: {
                guests: 3, adults: 3, children: 0, max: 3,
            },
            four: {
                guests: 4, adults: 4, children: 0, max: 4,
            },
            five: {
                guests: 5, adults: 5, children: 0, max: 5,
            },
            six: {
                guests: 6, adults: 6, children: 0, max: 6,
            },
            seven: {
                guests: 7, adults: 7, children: 0, max: 7,
            },
            eight: {
                guests: 8, adults: 8, children: 0, max: 8,
            },
            nine: {
                guests: 9, adults: 9, children: 0, max: 9,
            },
            ten: {
                guests: 10, adults: 10, children: 0, max: 10,
            },
            onePlusChild: {
                guests: 1, adults: 1, children: 1, max: 2,
            },
            doublePlusOneAdult: {
                guests: 2, adults: 2, children: 0, max: 3,
            },
            doublePlusOneChild: {
                guests: 2, adults: 2, children: 0, max: 3,
            },
            doublePlusOne: {
                guests: 2, adults: 2, children: 0, max: 3,
            },
            doublePlus: {
                guests: 2, adults: 2, children: 0, max: 3,
            },
            doublePlusTwoChildren: {
                guests: 2, adults: 2, children: 0, max: 4,
            },
            threePlus: {
                guests: 3, adults: 3, children: 0, max: 4,
            },
            fourPlusChild: {
                guests: 4, adults: 4, children: 0, max: 5,
            },
            fourPlus: {
                guests: 4, adults: 4, children: 0, max: 5,
            },
            fivePlusChild: {
                guests: 5, adults: 5, children: 0, max: 6,
            },
            fivePlus: {
                guests: 5, adults: 5, children: 0, max: 6,
            },
            sixPlusOne: {
                guests: 6, adults: 6, children: 0, max: 7,
            },
            sixPlus: {
                guests: 6, adults: 6, children: 0, max: 7,
            },
        };
        // Aparthotel Puerto Azul
        // For this property, doublePlus means 2 to 3 adults or 2 adults and 2 children
        if (thn.data.propertyId === 1010905) {
            peopleMap.doublePlus = {
                guests: 3, adults: 3, children: 0, max: 4,
            };
        }
        const peopleClasses = Object.keys(peopleMap);
        const roomSelectors = [
            // 08/01/2019 testing changing selector to higher selector
            // '.variationRoomStayPrice',
            // '.nonVariationsHolder .roomstayprice_price',
            // '.nonVariationsHolder .rp_val_top',
            // '.groupFromPrice .price',
            '#wrapper',
            '.variationStrip',
        ];
        let rooms = $(roomSelectors.join(' ')).map(function (idx, el) {
            const $el = $(el);
            // Avoiding Day Use rooms or Hotel67 (hotel definition starts with string 'Sleep67')
            let dayUsagePattern = 'day use|Room Office';
            if (thn.data.propertyId === 1026634) {
                dayUsagePattern += '|Sleep67';
            }
            if ($el.find('.v2-room-name.v2-tit')
                .text()
                .trim()
                .match(new RegExp(dayUsagePattern, 'i'))) {
                return {};
            }
            // 08/01/2019 see above change to room_selectors
            // const text = $el.text();
            // const $people = $el.closest('div[id]').find('.peopleIcon');
            const priceSelectors = [
                '.variationRoomStayPrice',
                '.nonVariationsHolder .roomstayprice_price',
                '.nonVariationsHolder .rp_val_top',
                '.groupFromPrice .price',
            ];
            const text = $el.find(priceSelectors.join(',')).eq(0).text();
            // const text = $(text_els[0]).text();
            const $people = $el.find('.peopleIcon');
            let people = { guests: 0 };
            let price = thn.parseNumber(text);
            // some special cases have a base price (without breakfast, etc.)
            //! this condition seems redundant, commented or not makes no difference
            const $basePrice = $el.closest('.variationStrip').find('.roomPrice.basePrice');
            if ($basePrice) {
                const basePrice = thn.parseNumber($basePrice.text());
                if (basePrice && basePrice < price) {
                    price = basePrice;
                }
            }
            const currencySymbol = (text.match(/[^\s\d,.]+/) || [])[0];
            const perStay = $el.siblings('[class*=_label]').text().match(/\d|total|gesamt|całkowita|celkem|ukupno/i);
            if (perStay) {
                price /= widgetData.nights;
            }
            // Checking occupancy via peopleIcon is not reliable on this pid as one icon can mean different occupancies
            if ($people.length) {
                // search the room greatest occupancy option
                $($people).attr('class').split(/\s+/).forEach(function (cl) {
                    // if the class gives us occupancy information
                    if (peopleClasses.includes(cl)) {
                        const roomRatePeople = peopleMap[cl];
                        /**  The rooms that ends with "Plus" lets the client add one child
                                     *   We need to identify those cases and add 1 to the max number of guests
                                     *   and set the number of children to 1
                                    */
                        if (defaultSearch.children === 1 && cl.match(/Plus$/)) {
                            roomRatePeople.max += 1;
                            roomRatePeople.children = 1;
                        }
                        const roomText = $el.find('div.variationStripTitle');
                        // To find out the number of people we do a search for the people icon. In some hotels, there
                        // is a description of the room where the number of children is added, which sometimes doesn't
                        // match the number of children indicated in the icon. We will use this check in case this description exists.
                        const checkChild = thn.parseNumber(roomText[0].textContent.match(engine._childrenSelectorTranslations())) || '';
                        if (checkChild) {
                            roomRatePeople.children = checkChild;
                            roomRatePeople.max = roomRatePeople.children + roomRatePeople.adults;
                        }
                        roomRatePeople.guests = roomRatePeople.children + roomRatePeople.adults;
                        // if the occupancy is bigger, keep this one
                        if (people.guests < roomRatePeople.max) {
                            people = roomRatePeople;
                        }
                    }
                });
            }
            return {
                price: price,
                currencySymbol,
                people: people,
            };
        }).toArray();
        // Check if the search is default (no forced 1 pax/2 pax rooms) and correct search_people
        // lower guests search to 1 only when one-guest-rooms are visible
        if (!isForcedSearch
            && !defaultSearch.userInput
            && rooms.filter((room) => room.people.guests < defaultSearch.guests).length === rooms.length) {
            Object.assign(defaultSearch, minimumSearch);
        }
        let validRooms = rooms.filter(function (room) {
            // if no people info is present
            // then this rooms can not be validated
            // by default consider it as valid
            if (!room.people) {
                return true;
            }
            // Return valid room if the property must show the lowest price no matter the amount of guests
            if ([1016837, 1026853].includes(thn.data.propertyId) || [1032914].includes(thn.data.accountUserId)) { // Hotel miguel angel, Hotel Acapulco Lloret and Arcotel
                return true;
            }
            // otherwise when the room does specify some of its guests as children
            if (room.people.children !== 0) {
                // then guests must fit AND adults must fit, then children will fit also
                return defaultSearch.guests <= room.people.max && defaultSearch.adults <= room.people.adults;
                // finally when the room doesn't specify children
            }
            // then just care about guests
            return defaultSearch.guests <= room.people.max;
        });
        // if there are rooms that admit the desired number of guests then use just those
        rooms = validRooms;
        if (rooms.length) {
            validRooms = true;
            // false if no rooms available with the desired number of guests
        }
        else {
            validRooms = false;
        }
        if (!rooms.length || $('#errorTable').length) { // #errorTable shows when searched dates are not available, but rooms can still appear.
            Object.assign(widgetData, defaultSearch);
            widgetData.noRooms = true;
        }
        else {
            // search the room
            widgetData.price = Number.MAX_VALUE;
            rooms.forEach(function (room) {
                if (room.price && room.price < widgetData.price) {
                    widgetData.price = room.price;
                    widgetData.currency = thn.getCurrencyCode(room.currencySymbol)
                        || (BA && (BA.userCurrencyCode || BA.currencyCode))
                        || widgetData.currency;
                    // if the room doesn't contain info about the guests OR
                    // if the guests search has been introduced by the user AND
                    // the rooms here fulfill the user input criteria
                    // then assign the user criteria as the final search
                    // EXCEPTION: do not assign user criteria on price_group presence, that is too risky.
                    if (!engine._hasPriceGroup() && (!room.people || (defaultSearch.userInput && validRooms === true))) {
                        Object.assign(widgetData, defaultSearch);
                        // otherwise use the room information as the guests search criteria
                    }
                    else {
                        Object.assign(widgetData, room.people);
                    }
                }
            });
            if (widgetData.price !== Number.MAX_VALUE) {
                widgetData.set = true;
                // Room Details Function Here
                widgetData.roomDetails = engine._roomDetailsParseData();
            }
            else {
                widgetData.price = undefined;
            }
        }
        if (thn.data.propertyId === 1014442 && widgetData.guests > 2) {
            widgetData.priceSpecial = 1;
        }
        if (thn.data.propertyId === 1014253 && (document.querySelector('#yourOffer') || {}).checked) {
            widgetData.priceSpecial = 1;
        }
        const standardRooms = $('span.variationRoomPackage').toArray().filter((roomTypes) => $(roomTypes).text().match('Standard'));
        if (thn.data.propertyId === 1016690 && thn.empty(standardRooms)) {
            widgetData.priceSpecial = 1;
        }
        return widgetData;
    };
    engine.priceParseData_v4 = function priceParseData_v4(ctx) {
        const widgetData = engine._priceParseDataCommon(ctx);
        const adults = thn.parseNumber(thn.parseUrlParameter('adults')) || 2;
        const children = thn.parseNumber(thn.parseUrlParameter('children')) || 0;
        const currency = thn.parseUrlParameter('user_currency');
        const pricesArray = [...document.querySelectorAll('[data-testid="ChooseRooms-VariationLowestRoomPrice"], .items-end .items-end')]
            .filter((room) => thn.isVisible(room))
            .map((room) => thn.parseNumber(room.textContent))
            .filter(Boolean);
        const noAvailability = !!document.querySelector('[data-headlessui-state="open"] .shadow-rooms-guests.bg-warning');
        widgetData.adults = adults;
        widgetData.children = children;
        if (!thn.empty(pricesArray) && currency && widgetData.nights) {
            widgetData.price = Math.min(...pricesArray) / widgetData.nights;
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    engine._roomDetailsParseData = function roomDetailsParseData() {
        const roomDetailsArray = [];
        /* Desktop Version */
        if (thn.data.media.name === 'desktop') {
            const roomSelector = document.querySelectorAll('.v2-box');
            if (roomSelector.length) {
                roomSelector.forEach(function (element, idx) {
                    const typeRoomSelector = {
                        Suite: 'suite',
                        Superior: 'superior',
                    };
                    const roomName = element.querySelector('.variationRoomPackage')?.childNodes[0]?.textContent?.toLowerCase().trim() || '';
                    const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
                    const roomAdults = element.querySelector('.icon-guest-two') ? 2 : 1;
                    const child = 0;
                    const priceInfo = element.querySelectorAll('.v2-room-item');
                    const roomData = {
                        id: '',
                        name: roomName,
                        adults: roomAdults,
                        children: child,
                        prices: [],
                    };
                    roomData.type = roomType;
                    if (priceInfo.length) {
                        priceInfo.forEach(function (priceUnit) {
                            const noRefundableRegex = (/no reembolsable|non refundable|bed & breakfast/);
                            const priceItemName = priceUnit.querySelector('.variationStripTitle')?.textContent;
                            const price = thn.parseNumber(priceUnit.querySelector('.variationRoomStayPrice')?.textContent);
                            const priceData = {
                                id: '',
                                name: priceItemName,
                                totalNight: price,
                                refundable: priceItemName.toLowerCase().match(noRefundableRegex) ? 0 : 1,
                            };
                            roomData.prices.push(priceData);
                        });
                        roomDetailsArray.push(roomData);
                    }
                    return roomData;
                });
            }
        }
        else {
            /* Mobile Version */
            const roomSelector = document.querySelectorAll('.v10-room-item');
            if (roomSelector.length) {
                let lastRoomName = '';
                roomSelector.forEach(function (element, idx) {
                    //-----
                    lastRoomName = roomDetailsArray.length && roomDetailsArray.slice(-1)[0].name;
                    const typeRoomSelector = {
                        Suite: 'suite',
                        Superior: 'superior',
                    };
                    const roomName = element.querySelector('.v10-room-item-vg')?.textContent || '';
                    const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
                    const roomAdults = element.querySelector('.icon-guest-double') ? 2 : 1;
                    const child = 0;
                    const roomData = {
                        id: '',
                        name: roomName,
                        adults: roomAdults,
                        children: child,
                        prices: [],
                    };
                    roomData.type = roomType;
                    const noRefundableRegex = (/no reembolsable|non refundable|bed & breakfast/);
                    const priceItemName = element.querySelector('.v10-room-name')?.textContent;
                    const price = thn.parseNumber(element.querySelector('.v10-room-price-final')?.textContent);
                    const priceData = {
                        id: '',
                        name: priceItemName,
                        totalNight: price,
                        refundable: priceItemName.toLowerCase().match(noRefundableRegex) ? 0 : 1,
                    };
                    // In case if the room is duplicated we push the prices in the previous room
                    if (lastRoomName === roomName) {
                        roomDetailsArray.slice(-1)[0].prices.push(priceData);
                    }
                    else {
                        roomData.prices.push(priceData);
                        roomDetailsArray.push(roomData);
                    }
                    return roomData;
                });
            }
        }
        return roomDetailsArray;
    };
    /**
       * @memberOf module:bs_2
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const booking = document.querySelector('.v2-confirmation');
        if (!thn.baBcObserveDom && booking && document.querySelector('.v2-loader')) {
            thn.baBcObserveDom = thn.debounce(function baBcObserveDom() {
                if (!document.querySelector('.v2-loader')
                    && ctx.widget.setData().isSet()) {
                    ctx.widget.save();
                    thn.stopObserveDom(booking, thn.baBcObserveDom);
                    delete thn.baBcObserveDom;
                }
            }, 500);
            // Init body observation
            thn.observeDom(booking, thn.baBcObserveDom);
            thn.pageUnload(function () {
                // The observer might have been already deleted
                if (thn.baBcObserveDom) {
                    thn.stopObserveDom(booking, thn.baBcObserveDom);
                    delete thn.baBcObserveDom;
                }
            });
        }
    };
    /**
       * Uses global object <tt>window.BA.rrDoc</tt>.
       *
       * Implements **bookingId**.
       *
       * @memberOf module:bs_2
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData() {
        const widgetData = {};
        const BA = window.BA && window.BA.rrDoc;
        if (BA) {
            widgetData.dateBegin = BA.arrival?.replace(/-/g, '/');
            widgetData.dateEnd = BA.departure?.replace(/-/g, '/');
            if (BA.bookingAmount && BA.currencyCode) {
                widgetData.price = BA.bookingAmount;
                widgetData.currency = BA.currencyCode;
            }
            else if (BA.bookingAmountUserCurrency && BA.userCurrencyCode) {
                // Example --> bookingAmountUserCurrency: "COP 1011115 (US$ 347.70)"
                // Pick the last number of the user amount
                widgetData.price = thn.parseNumber(BA.bookingAmountUserCurrency.match(/[\d,.]+\D*$/)[0]);
                widgetData.currency = BA.userCurrencyCode;
            }
            if (BA.promoCode) {
                widgetData.promocode = BA.promoCode;
            }
            if (BA.bookingReference) {
                widgetData.bookingId = BA.bookingReference;
            }
        }
        else {
            if (document.querySelectorAll('div[itemscope]').length
                && [...document.querySelectorAll('div[itemscope]')].filter((el) => el.getAttribute('itemtype') && el.getAttribute('itemtype') === 'http://schema.org/LodgingReservation').length) {
                const bookingEl = [...document.querySelectorAll('div[itemscope]')].filter((el) => el.getAttribute('itemtype') === 'http://schema.org/LodgingReservation')[0];
                const bookingId = [...bookingEl.childNodes].filter((bookingDataEl) => bookingDataEl.getAttribute('itemprop') === 'reservationNumber')[0];
                const dateBegin = [...bookingEl.childNodes].filter((bookingDataEl) => bookingDataEl.getAttribute('itemprop') === 'checkinDate')[0];
                const dateEnd = [...bookingEl.childNodes].filter((bookingDataEl) => bookingDataEl.getAttribute('itemprop') === 'checkoutDate')[0];
                const price = [...bookingEl.childNodes].filter((bookingDataEl) => bookingDataEl.getAttribute('itemprop') === 'price')[0];
                const currency = [...bookingEl.childNodes].filter((bookingDataEl) => bookingDataEl.getAttribute('itemprop') === 'priceCurrency')[0];
                widgetData.bookingId = bookingId && bookingId.getAttribute('content');
                widgetData.dateBegin = dateBegin && dateBegin.getAttribute('content')?.replace(/-/g, '/');
                widgetData.dateEnd = dateEnd && dateEnd.getAttribute('content')?.replace(/-/g, '/');
                widgetData.price = price && parseFloat(price.getAttribute('content'));
                widgetData.currency = currency && currency.getAttribute('content');
            }
            else {
                widgetData.bookingId = thn.parseUrlParameter('ref') || window.mhsCV?.reservationnumber || window.baBookingTrackerData?.purchase?.bookingReference || window.bARes?.bookingReference || document.querySelector('.v2-booking-status strong')?.textContent;
                widgetData.dateBegin = window.baBookingTrackerData?.request?.arrivalDate || window.ftb?.checkInDate?.replace(/-/g, '/');
                widgetData.dateEnd = window.baBookingTrackerData?.request?.departureDate || window.ftb?.checkOutDate?.replace(/-/g, '/');
                widgetData.price = window.mhsCV?.revenue || window.ftb?.orderValue || window.baBookingTrackerData?.purchase?.revenue || thn.parseNumber(window.bARes?.totalBookingCostCustomerFormatted) || thn.parseNumber(document.querySelector('.v2-booking-summary-totals dd')?.textContent);
                widgetData.currency = window.mhsCV?.currency || window.baBookingTrackerData?.request?.userCurrency || window.bARes?.currency || thn.parseCurrency(document.querySelector('.v2-booking-summary-totals dd')?.textContent);
            }
            if (document.querySelector('.v2-booking-details-promocode')) {
                const promocodeEl = document.querySelector('.v2-booking-details-promocode').textContent.split(' ');
                if (promocodeEl.length > 0) {
                    widgetData.promocode = promocodeEl[promocodeEl.length - 1];
                }
            }
        }
        if (document.querySelector('.v2-loader')) {
            widgetData.set = false;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_2
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const $ = window.jQuery;
        const promocode = thn.parseUrlParameter('promo_code') || thn.parseUrlParameter('voucher_code');
        if ($ && $('#errorTable:contains(promo):visible').length) {
            // The promocode is not valid
            ctx.promocode = '';
        }
        else if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
